module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"title":"評論已完成。","subtitle":"感謝您的寶貴評價。","reward":"預計贈送 {0}","my_reviews_button":"查看我的評論"}}')
  delete Component.options._Ctor
}
